import { createContext } from "react"

const AppContext = createContext({
    setCollapsed: () => {},
})
export default AppContext


// WEBPACK FOOTER //
// ./src/views/AppViews/context.js